import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-district-wise-report',
  templateUrl: './district-wise-report.component.html',
  styleUrls: ['./district-wise-report.component.css']
})
export class DistrictWiseReportComponent implements OnInit {
  title="PSA District wise Report";
  toDay ;
  constructor() {    
    this.toDay = new Date();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/view/rpt-form/report-list/district-wise-report/district-wise-report.component.ts